import React, { useEffect, useState } from 'react'
import { useTranslate } from '../TranslationText';
import { getHorseListByAuctionId } from '../../pages/auctionDetails/api/auctionApis';
import AuctionHorse from './AuctionHorse';
import SubmitServiceBtn from '../servicesButtons/SubmitServiceBtn';
import { eFormButtonsContainer, noDataCard } from '../../common/cssclasses';
import Loader from '../Loader';

export default function HorseList({ auctionId, auction }) {
    const [activeTab, setActiveTab] = useState('All');
    const [horses, setHorses] = useState([]);
    const [loading, setLoading] = useState(false);
    const { translate } = useTranslate();
    const skip = 0;
    const take = 12;
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        setLoading(true);
        getHorseListByAuctionId(auctionId, activeTab, skip, take).then((res) => {
            setHorses(res?.result);
            setTotalCount(res?.totalCount);
            setLoading(false);
        })
    }, [])

    function loadMoreHorses() {
        getHorseListByAuctionId(auctionId, activeTab, horses.length, take).then((res) => {
            setHorses((prev) => [...prev, ...res?.result]);
            setTotalCount(res?.totalCount);
            setLoading(false);
        })
    }

    function changeTab(tabName) {
        setActiveTab(tabName);
        setLoading(true);
        getHorseListByAuctionId(auctionId, tabName, 0, take).then((res) => {
            setHorses(res?.result);
            setTotalCount(res?.totalCount);
            setLoading(false);
        })
    }

    return (
        <>
            <div className="row mx-0 rtl">
                <div
                    className={'col-4  text-center px-0 mb-main'}
                    style={{ cursor: 'pointer' }}
                    id="second_most_used_services"
                    onClick={() => {
                        changeTab('All')
                    }}
                >
                    <span className={`${activeTab == 'All' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.all", "All")}</span>
                    <div className="service_bar_underline" style={activeTab == 'All' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
                <div
                    className={'col-4  text-center px-0 mb-main'}
                    id="second_registration_services"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        changeTab('Sold')
                    }}
                >
                    <span className={`${activeTab == 'Sold' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.sold", "Sold")}</span>
                    <div className="service_bar_underline" style={activeTab == 'Sold' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
                <div
                    className={'col-4  text-center px-0 mb-main'}
                    id="second_notarisation_services"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        changeTab('Unsold')
                    }}
                >
                    <span className={`${activeTab == 'Unsold' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.Unsold", "Unsold")}</span>
                    <div className="service_bar_underline" style={activeTab == 'Unsold' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
            </div>
            <div className='row'>
                {loading ? <>
                    <Loader />
                </> : <>

                    {horses?.map((horse, index) => (
                        <AuctionHorse auction={auction} horse={horse} />
                    ))}
                </>}
            </div>
            {!loading && horses.length == 0 &&
                <div className={noDataCard}>
                    <div className='red' >
                        {translate('web.nodatafound', 'No Horses')}
                    </div>
                </div>
            }
            {totalCount > horses.length &&
                <div className={'col-md-12 col-sm-12 d-flex justify-content-center flex-wrap'}>
                    <SubmitServiceBtn
                        onClick={() => loadMoreHorses()}
                        key={'loadMore'}
                        text={translate('web.loadMore')}
                    />
                </div>
            }
        </>
    )
}
